<template>

  <div class="workspace" v-if="order">

    <div v-if="isSendRestaurant"  data-vv-scope="add-user" class="user-edit-cont">
      <div class="user-edit-row">
        <h4>Restaurants</h4>
        <multiselect name="Restaurants" v-validate="'required'" v-model="selected_restaurants"
                     label="label" track-by="label" :multiple="true"
                     :options="getUserListByGroup(2)">
        </multiselect>
      </div>
      <div class="tr-button green-button" @click="sendRestaurant">Send Restaurants</div>
      <div class="tr-button green-button inactive" @click="isSendRestaurant = false">CANCEL</div>
    </div>

    <div class="section-heading">
      <h2>Order Details</h2>
<!--      <a href="#"><div class="tr-button green-button" @click="printReceipt"><i class="fas fa-print"></i> Print This Order</div></a>-->
    </div>

    <div class="order-detail-top">
      <h2>Order #: {{ order.id }}</h2>
      <div class="order-detail-section">
        <div class="order-detail">
          <h3>Customer Name</h3>
          <h4>{{`${order.full_name}` }}</h4>
        </div>
        <div class="order-detail">
          <h3>Customer Phone</h3>
          <h4>{{ order.phone }}</h4>
        </div>
        <div class="order-detail">
          <h3>Delivery Method</h3>
          <h4>{{ order.delivery_type_name }}</h4>
        </div>
        <div class="order-detail">
          <h3>{{order.delivery_type === 1? 'Delivery' : 'Pickup'}} Address</h3>
          <h4 v-if="order.delivery_type === 1"> {{order.address}} {{order.houseNum}} {{order.city}}, {{order.state}}  {{order.postcode}}</h4>
          <h4 v-else>{{selectedRestaurant.user_property['Address']}}</h4>
        </div>
        <div class="order-detail">
          <h3>Event Date</h3>
          <h4>{{ formatDate(order.date_to_event) }}</h4>
        </div>
        <div class="order-detail">
          <h3>Notes</h3>
          <h4> {{order.notes}}</h4>
        </div>
      </div>
      <div class="order-status">
        <h3>Order Status</h3>
        <div class="order-status-inner" v-if="![0,5].includes(order.status)">

          <select class="tr-input"  v-model="order_status">

            <option v-for="option in order_statuses"
                    :key="option.value"
                    :value="option.value">{{ option.label }}</option>
          </select>

          <div class="tr-button green-button" @click="updateStatus">Change Status</div>
        </div>
        <div class="order-status-inner" v-else>
          <div class="tr-button green-button inactive" v-if="order.status===0">Cancelled</div>
          <div class="tr-button green-button inactive" v-if="order.status===5">Completed</div>
        </div>

      </div>
    </div>
    <div class="order-detail-middle">
      <div class="order-detail-list catering">
<!--        <div class="order-list-header">
          <div class="order-list-header-item">Qty</div>
          <div class="order-list-header-item">Item</div>
          <div class="order-list-header-item">Price</div>
        </div>-->
        <div class="order-list-body">
          <div class="order-list-row" v-for="product in order.orderProduct" :key="product.id">
            <div class="order-list-body-item" >{{product.quantity}}</div>
            <div class="order-list-body-item" >{{product.product_name}}
              <div class="item-addon-wrap" v-if="product.modifier.length > 0" v-for="modifier in product.modifier" :key="modifier.id">
                <div class="item-addon">{{modifier.modifier_item_name}}</div>
              </div>
            </div>
            <div class="order-list-body-item">${{formatPrice(product.totalPrice)}}
              <div class="item-addon-wrap">
<!--                <div class="item-addon-wrap" v-if="product.modifier.length > 0" v-for="modifier in product.modifier" :key="modifier.id">
                  <div class="item-addon">{{formatPrice(modifier.price)}}</div>
                </div>-->
              </div>
            </div>
<!--            <div class="order-list-body-item">
              <div class="item-addon-wrap">
                <div class="item-addon-wrap" v-if="product.modifier.length > 0" v-for="modifier in product.modifier" :key="modifier.id">
                </div>
              </div>
            </div>-->
          </div>
        </div>
        <div class="order-sum">
          <h3 class="">SubTotal</h3>
          <h3 class="item">${{ formatPrice(order.product_price) }}</h3>
        </div>
        <div class="order-sum">
          <h3 class="">Tax</h3>
          <h3 class="item">${{ formatPrice(order.tax) }}</h3>
        </div>
        <div class="order-sum">
          <h2 class="font-bold">Total</h2>
          <h3 class="item">${{ formatPrice(order.total_amount) }}</h3>
        </div>
      </div>
    </div>
<!--    <vs-prompt
      @cancel="cancelRefund"
      @accept="refundOrder"
      @close="cancelRefund"
      title="Refund Order"
      :is-valid="refund_amount > 1"
      :active.sync="refundPrompt">
      <div class="con-exemple-prompt">
        Please enter the amount you want to refund below
        <vs-input class="p-2" placeholder="Amount" type="number" v-model="refund_amount"/>
        <vs-alert :active="refund_amount <= 1" color="danger" icon="new_releases" >
          Refund amount must be greater than $1
        </vs-alert>
      </div>
    </vs-prompt>
    <vs-prompt
      @cancel="reason=''"
      @accept="cancelOrder"
      @close="cancelCancel"
      title="Cancel Order"
      :is-valid="reason !== ''"
      :active.sync="cancelPrompt">
      <div class="con-exemple-prompt">
        Please state your reason below
        <vs-input class="p-2" placeholder="Reason" v-model="reason"/>
        <vs-alert :active="reason === ''" color="danger" icon="new_releases" >
          Field can not be empty please enter the reason
        </vs-alert>
      </div>
    </vs-prompt>-->
<!--    <print-pdf-template v-if="print" :order="order" :filename="`Catering_Order_${order.id}`"/>-->
  </div>
</template>

<script>
import DataViewSidebar from './DataViewSidebar.vue'
// import SendRestaurantSidebar from './SendRestaurantSidebar.vue'
import vSelect from 'vue-select'
import printPdfTemplate from './printPdfTemplate'
import moment from 'moment/moment'

export default {
  components: {
    DataViewSidebar,
    vSelect,
    printPdfTemplate
    // SendRestaurantSidebar
  },
  props: {
    orderId: String
  },
  data () {
    return {
      selected_restaurants: null,
      isSendRestaurant: false,
      isMounted: false,
      order: null,
      cateringOrderOffers: null,
      reason: '',
      cancelError: '',
      refund_amount: 0,
      cancelPrompt: false,
      refundPrompt: false,
      order_status: 1,
      print: false,
      user_group: 2,
      offer: {},
      user_group_options:
        [{label: 'New', value: 1}, {label: 'Preparing', value: 2}, {label: 'Out for Delivery', value: 4}, {label: 'Completed', value: 5}]
    }
  },
  computed: {
    orderOffers () {
      return this.$store.state.api.cateringOrderOffers
    },
    activeUserInfo () {
      return this.$store.state.api.currentUser
    },
    userlists () {
      return this.$store.state.api.userlists
    },
    rawlistdata () {
      let  data_array = []
      this.userlists.map((list) => {
        data_array = [...data_array, ...list]
      })
      return data_array
    },
    selectedRestaurant () {
      let obj = this.$store.state.api.selectedRestaurant
      if (!obj) {
        try {
          obj = JSON.parse(localStorage.getItem('selectedRestaurant'))
        } catch (e) {
          obj = null
        }

      }
      return obj
    },
    order_statuses () {
      return this.$store.state.api.orderStatuses.map(status => {
        return {
          label: !status.name.includes('Checkout') ? status.name : 'Complete',
          value: status.id
        }
      })
    }
  },
  watch: {
    '$store.state.api.selectedRestaurant' (val) {
      if (val) {
        this.$router.push({name: 'orders'})
      }
    }
  },
  methods: {
    filterType (user, type) {
      return user.user_group === type
    },
    getUserList (group_id) {
      // Loading

      const payload = {
        user_group: group_id,
        user: this.activeUserInfo
      }

      this.$vs.loading()

      this.$store.dispatch('api/getUsersRaw', payload)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    getUserListByGroup (group) {
      const users = this.rawlistdata.filter((user) => this.filterType(user, Number.parseInt(group)))
      const options_array = []

      users.map(user => {
        const option = {
          label: user.user_property['Restaurant-Name'],
          value: user.id
        }
        options_array.push(option)
      })
      return options_array
    },
    formatDate (value) {
      if (value) {
        return moment(String(value), 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm')
      }
    },
    getOrderStatuses () {
      this.$store.dispatch('api/getOrderStatuses')
        .then(() => {
        })
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    formatPrice (value) {
      const val = (value / 1).toFixed(2)
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    printReceipt () {

      this.print = true
      setTimeout(() => {
        this.print = false
      }, 500)

    },
    openAlert (text) {
      this.$vs.dialog({
        type:'alert',
        color: 'success',
        clickNotClose: true,
        title: 'Confirm',
        acceptText: 'Ok',
        text: `${text}`
      })
    },
    openAlertConfirm (text, accept, cancel) {
      this.$vs.dialog({
        type:'alert',
        color: 'success',
        clickNotClose: true,
        title: 'Confirm',
        acceptText: 'Ok',
        text: `${text}`,
        accept,
        cancel
      })
    },
    openConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirm',
        clickNotClose: true,
        text: `Are you sure you want to cancel order #${this.order.id}?`,
        accept,
        cancel
      })
    },

    cancelCancel () {

    },
    cancelRefund () {

    },
    refundOrder () {
      this.openConfirm(() => {
        this.order_status = 6
        this.$vs.loading()
        const obj = {
          orderId: this.orderId,
          status: this.order_status,
          amount: this.refund_amount
        }

        this.$store.dispatch('api/setOrderStatus', obj)
          .then(() => {
            this.$vs.loading.close()
            this.openAlert(`Total ${this.refund_amount} refunded`)
            this.refund_amount = 0
            this.getOrder()
          })
          .catch(err => {
            this.$vs.loading.close()
            console.error(err)
          })
      }, () => {

      })
    },
    cancelOrder () {
      if (this.reason !== '') {
        this.order_status = 0
        const obj = {
          orderId: this.orderId,
          status: this.order_status,
          reason: this.reason
        }
        let status_text = 'Cancelled'
        if (this.order_status !== 0) {
          status_text = this.order_status.filter(option => {
            return option.value === this.order_status
          })[0].label

        }

        this.$store.dispatch('api/setOrderStatus', obj)
          .then(() => {
            this.$vs.loading.close()
            this.cancelPrompt = false
            if (status_text) {
              this.openAlert(status_text)
            }
            this.cancelError = ''
          })
          .catch(err => {
            this.$vs.loading.close()
            console.error(err)
          })
      } else {
        this.cancelPrompt = true
        this.cancelError = 'Please enter reason to proceed'
      }
    },
    updateStatus () {
      this.$vs.loading()
      const obj = {
        orderId: this.orderId,
        status: this.order_status
      }
      let status_text = 'Cancelled'
      if (this.order_status !== 0) {
        status_text = this.order_statuses.filter(option => {
          return option.value === this.order_status
        })[0].label

      }

      this.$store.dispatch('api/setCateringOrderStatus', obj)
        .then(() => {
          this.$vs.loading.close()
          if (status_text) {
            this.openAlertConfirm(status_text, () => {
              this.getOrder()
            }, () => {
              this.getOrder()
            })
          }
        })
        .catch(err => {
          this.$vs.loading.close()
          console.error(err)
        })
    },
    getOrderStatusColor (status) {
      if (status === 0)   return 'status-0'
      if (status === 1) return 'status-1'
      if (status === 2)  return 'status-2'
      if (status === 3)  return 'status-3'
      if (status === 4)  return 'status-4'
      if (status === 5)  return 'status-5'
      if (status === 6)  return 'status-6'
      return 'primary'
    },
    getOrder () {
      const payload = {
        cateringOrderId: this.orderId
      }
      this.$store.dispatch('api/getCateringOrder', payload)
        .then((response) => {
          this.order = response
          this.order_status = this.order.status
          this.refund_amount = this.order.total_amount
        })
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    getCateringOrderOffers () {
      const payload = {
        cateringOrderId: this.orderId
      }
      this.$vs.loading()

      this.$store.dispatch('api/getCateringOrderOfferList', payload)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: 'An error occurred',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    sendRestaurant () {
      this.$vs.loading()
      const selected_restaurant_payload = []

      this.selected_restaurants.map(option => {
        selected_restaurant_payload.push(option.value)
      })
      let message = ''

      const payload = {
        cateringOrderId: this.orderId,
        restaurants: selected_restaurant_payload
      }
      this.$store.dispatch('api/cateringSendRestaurant', payload).then((response) => {
        this.offer = response
        message = response.data.message
        this.$vs.loading.close()
        this.openAlert(message)
        this.isSendRestaurant = false
      }).catch(error => {
        this.$vs.notify({
          title: 'Error',
          text: error.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })

    }
  },
  created () {
  },
  mounted () {
    this.isMounted = true
    this.getUserList(2)
    this.getOrderStatuses()
    this.getOrder()
    this.getCateringOrderOffers()
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.con-exemple-prompt {
  .vs-component {
    width: 100%;
    .vs-input--placeholder.normal {
      padding: 5px 10px !important;
    }
  }
}
</style>
